<template>
  <div class="z-10 flex flex-wrap justify-center tracking-widest">
    <template v-for="(tag, idx) in tags" :key="tag.uuid">
      <span v-if="idx > 0" class="px-1">|</span>
      <nuxt-link
        :to="
          toLocalePath({
            name: 'magazine',
            query: {
              tag: isSelectedTag(tag.uuid) ? undefined : tag.uuid,
            },
          })
        "
        class="px-2 text-black transition-colors hover:text-gray-secondary"
        :class="isSelectedTag(tag.uuid) && 'bg-platin'"
        @click="
          trackBlogTag({
            blog_tag: (tag.content && tag.content.title) || tag.name || '',
            blog_section: placement,
          })
        "
      >
        {{ getName(tag) }}
        <Icon
          v-if="showDeselectIcon && isSelectedTag(tag.uuid)"
          icon="close"
          size="3"
        />
      </nuxt-link>
    </template>
  </div>
</template>

<script lang="ts">
import Icon from '#layers/base/components/ui/icons/Icon.vue'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import type {
  Sbtag,
  StoryblokStory,
} from '~/cms/storyblok/types/storyblok.d.ts'

export default defineComponent({
  components: {
    Icon,
  },
  props: {
    tags: {
      type: Array as PropType<StoryblokStory<Sbtag>[]>,
      required: true,
    },
    selectedTagUuids: {
      type: Array as PropType<(string | null)[] | undefined>,
      default: () => [],
    },
    showDeselectIcon: {
      type: Boolean as PropType<boolean>,
      default: () => false,
    },
    placement: {
      type: String as PropType<'header' | 'big teaser' | 'blog article'>,
      required: true,
    },
  },
  setup(props) {
    const isSelectedTag = (tagUuid: string) =>
      props.selectedTagUuids?.includes(tagUuid)
    const { trackBlogTag } = useTrackingEvents()
    const { locale } = useCurrentShop().value
    const { toLocalePath } = useRouteHelpers()

    return {
      toLocalePath,
      isSelectedTag,
      trackBlogTag,
      getName: (tag: StoryblokStory<Sbtag>) =>
        tag.translated_slugs?.find((slug) => slug.lang === locale)?.name ||
        tag.name,
    }
  },
})
</script>
